/* eslint-disable no-param-reassign */
import { LeadsRequest } from '../types/leadsRequest';

export const setData = <K extends keyof LeadsRequest>(key: K, value: LeadsRequest[K], data: LeadsRequest) => {
  data[key] = value;
};
